import { apiClient } from '@/core/api/client';
import { Endpoints } from '@/core/api/endpoints';

/** Values accepted by POST /v1/customers/updateTopUpType `topUpType`. */
export const TOP_UP_TYPE = {
  MORTGAGE: 'Mortage_Bank_Loan',
  BANK_TRANSFER: 'Bank_Transfer_Cash',
} as const;

export type TopUpType = (typeof TOP_UP_TYPE)[keyof typeof TOP_UP_TYPE];

export interface UpdateTopUpTypeRequest {
  topUpType: TopUpType;
}

export interface UpdateTopUpTypeResponse {
  status?: string;
  message?: string;
}

export async function updateTopUpType(
  topUpType: TopUpType,
): Promise<UpdateTopUpTypeResponse> {
  return apiClient.post<UpdateTopUpTypeResponse, UpdateTopUpTypeRequest>(
    Endpoints.profile.updateTopUpType,
    { topUpType },
  );
}
